const schedulerExploreViewTypes = {
  EXPLORE_VIEW_SET_SELECTED_WEEK: "EXPLORE_VIEW_SET_SELECTED_WEEK",
  SET_NURSE_DAY_BOOKINGS: "SET_NURSE_DAY_BOOKINGS",
  SET_SELECTED_MONTH: "SET_SELECTED_MONTH",
  SET_SELECTED_DAY: "SET_SELECTED_DAY",
  SET_SEARCH_INPUT_VALUE: "SET_SEARCH_INPUT_VALUE",
};

export default schedulerExploreViewTypes;
